module.exports = __webpack_public_path__ + "static/aquis_logo-47c90acbb8dcdc364cadf4ea3b001b2c.png";